/** DB role names that grant the same access as their canonical nav/API role. */
const ROLE_ALIASES = {
  'CRYR Admin': 'Business Admin',
  'CRYR User': 'Business User',
  'CRYR Customer User': 'Customer User',
};

/** Primary app navigation for CRYR Admin (cryradmin) and equivalent roles. */
export const CRYR_ADMIN_NAV_ROLES = [
  'Super Admin',
  'System Admin',
  'Business Admin',
  'CRYR Admin',
];

export const resolveRole = (role) => ROLE_ALIASES[role] || role;

export const isRoleAllowed = (currentRole, allowedRoles) => {
  if (!allowedRoles || allowedRoles.length === 0) return true;
  if (!currentRole) return false;
  if (currentRole === 'Super Admin') return true;

  const effectiveRole = resolveRole(currentRole);
  return allowedRoles.includes(currentRole) || allowedRoles.includes(effectiveRole);
};
